var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatheredhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714 410.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a56f46;}.cls-2{fill:#c5e6e2;}.cls-3{fill:#92633c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.36,180.5s177-192.64,354.64,1Z",
    transform: "translate(-27 -41.91)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.54,187.09S594.5,69,686.46,41.91c0,0-16.82,53.44-22.48,65.05l-34,20.13,29-3.47S592.69,191.35,552.54,187.09Z",
    transform: "translate(-27 -41.91)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384,155.5c-197.17,0-357,82.38-357,184,0,42.41,27.85,81.47,74.64,112.59C106,406.64,121,330.35,172.78,284.54c35.58-31.5,73.66-53.92,107.57-65.38h0a184.7,184.7,0,0,1,21.53-5.92c32.92-8,98.77-20,163.19-7.84h0c41.21,5.42,94.76,35.14,142.26,82.64,47.16,47.16,60,117.43,63.1,161.29C714.76,418.67,741,380.66,741,339.5,741,237.88,581.17,155.5,384,155.5Z",
    transform: "translate(-27 -41.91)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatheredhat);
export default __webpack_public_path__ + "static/media/feathered hat.9abe229f.svg";
export { ForwardRef as ReactComponent };